import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CadastroService } from 'src/app/services/cadastro.service';
import { HttpErrorResponse } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@Component({
    selector: 'app-alt-senha',
    templateUrl: './alt-senha.component.html',
    styleUrls: ['./alt-senha.component.css'],
    imports: [FormsModule, ReactiveFormsModule]
})
export class AltSenhaComponent implements OnInit {
  @Input() parentForm!: FormGroup;

  loading: boolean = false;
  msgErro: string = null;
  form: FormGroup = null;

  constructor(private cadastro: CadastroService, private toastr: ToastrService) {
    this.form = new FormGroup({
      senhaAtual: new FormControl(null, [Validators.required]),
      novaSenha: new FormControl(null, [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/)
          ]),
      novaSenhaConf: new FormControl(null, [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/)
          ])
    });
  }

  ngOnInit() {

  }

  salvarAltSenha(): boolean {

    if(!this.validarSenha()){

      setTimeout(()=>{
        this.msgErro = null;
      }, 5000);

      return false;
    }


    this.loading = true;

    this.cadastro
        .alterarSenha(this.form.value)
        .pipe(
          finalize(() => { this.loading=false })
        )
        .subscribe(
          (res: boolean) => {

            if(res){
              this.toastr.success("Senha Alterada com sucesso");
              this.form.reset();
            }

          },
          (error: HttpErrorResponse) => {

            this.msgErro = error.error.ex;

            if(error.error.type=="validacaoIgual" || error.error.type=="validacaoTamanho"){
              this.form.get("novaSenha").setValue("");
              this.form.get("novaSenhaConf").setValue("");
            }

            if(error.error.type=="erroAoSalvar"){
              this.form.get("senhaAtual").setValue("");
            }

            setTimeout(()=>{
              this.msgErro = null;
            }, 5000);

          }
        )

    return true;
  }

  validarSenha(): boolean{

    var novaSenha: string = this.form.get("novaSenha").value;
    var novaSenhaConf: string = this.form.get("novaSenhaConf").value;


    if(novaSenha != novaSenhaConf){
      this.msgErro = "As senhas não são iguais";
      return false;
    }

    return true;
  }


}
